<template>
  <div class="max-w-xl m-auto">
    <service-orders-search
      @searchClick="handleSearchByOrderId"
      @searchStatus="handleSearchByStatus"
      :loading="loadingListServiceOrders"
    />

    <service-orders-list
      :items="items"
      :loading="loadingListServiceOrders"
      :pagination="pagination"
      @onPrevious="onPrevious"
      @onNext="onNext"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ServiceOrders',
  components: {
    ServiceOrdersList: () => import('./ServiceOrdersList.vue'),
    ServiceOrdersSearch: () => import('./ServiceOrdersSearch.vue')
  },
  computed: {
    ...mapGetters(['physicalWorldOrders', 'loadingListServiceOrders']),
    items () {
      return this.physicalWorldOrders?.content ?? []
    },
    pagination () {
      return this.physicalWorldOrders?.pagination ?? {}
    }
  },

  methods: {
    ...mapActions({ getPhysicalWorldOrders: 'GET_PHYSICAL_WORLD_ORDERS' }),
    onPrevious () {
      this.$router.replace({
        query: { ...this.$route.query, page: this.pagination.current_page - 1 }
      })

      this.getPhysicalWorldOrders(this.$route.query)
    },
    onNext () {
      this.$router.replace({
        query: { ...this.$route.query, page: this.pagination.current_page + 1 }
      })

      this.getPhysicalWorldOrders(this.$route.query)
    },
    handleSearchByOrderId (orderId) {
      const query = { ...this.$route.query, page: 1, size: 10 }

      if (!orderId) {
        delete query.id
      } else {
        query.id = orderId
      }

      this.$router.replace({
        query: { ...query }
      })
      this.getPhysicalWorldOrders(this.$route.query)
    },
    handleSearchByStatus (status) {
      const query = { ...this.$route.query, page: 1, size: 10 }

      if (status === null) {
        delete query.status
      } else {
        query.status = status.value
      }

      this.$router.replace({
        query
      })

      this.getPhysicalWorldOrders(query)
    }
  }
}
</script>
